<template>
  <modal name="update-alarm" class="modal-inner modal-update-alarm" transition="pop-out" :width="modalWidth" :focus-trap="true" :min-height="600" height="auto" :scrollable="true" :resizable="true" :adaptive="true" :reset="true" @before-close="resetForm">
    <span class="close-button" @click="hide('update-alarm')"><BaseIcon icon="times-circle" class="text-white"/></span>
    <div class="modal-header text-lg bg-primary-50 font-serif">
      <span v-if="updateInfo">{{ updateInfo.unit_name }}</span>
    </div>
    <div class="modal-body">
      <ValidationObserver ref="formUpdateAlarm" v-if="updateInfo != null">
        <div class="flex flex-wrap border-b border-secondary-500 mx-2 pb-4 mb-5">
          <div class="w-full md:w-1/2">
            <div class="flex flex-wrap" v-if="!/(SRT334)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(AJAX)|(SecurDesktop)/.test(updateInfo.type) && updateInfo.gps_active && updateInfo.lastSeen">
              <div class="small">
                <span v-if="new RegExp('^SRT').test(updateInfo.type)" class="last-seen mr-2 text-sm" v-bind:class="{ inactive: updateInfo.lastSeenTime > 1000 * 60 * 60 }">⬤</span>
                <span v-if="new RegExp('^TWIG').test(updateInfo.type)" class="last-seen mr-2 text-sm" v-bind:class="{ inactive: updateInfo.lastSeenTime > 1000 * 60 * 60 * 2.5 }">⬤</span>
                <span v-if="new RegExp('^EMERIT').test(updateInfo.type) || updateInfo.type === 'securapp_eb10'" class="last-seen mr-2 text-sm" v-bind:class="{ inactive: updateInfo.lastSeenTime > 1000 * 60 * 60 }">⬤</span>
                <span v-if="new RegExp('^TELTONIKA').test(updateInfo.type)" class="last-seen mr-2 text-sm" v-bind:class="{ inactive: updateInfo.lastSeenTime > 1000 * 60 * 60 }">⬤</span>
                <span class="text-xs">{{ updateInfo.lastSeen }}</span>
              </div>
              <router-link v-if="!/(4G Box)/.test(updateInfo.type) && checkAddons()" class="btn-green-outline ml-4" :to="'/gps-unit/customer/' + updateInfo.parent_id + '/-/' + updateInfo._id" target="_blank">
                Track
                <BaseIcon icon="map-marker-alt" />
              </router-link>
            </div>
            <div class="flex flex-wrap" v-if="/(SRT334)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(AJAX)|(SecurDesktop)/.test(updateInfo.type) && updateInfo.lastSeen">
              <div class="small">
                <span class="last-seen mr-2 text-sm" v-bind:class="{ inactive: updateInfo.tagLastSeen > 7 }">⬤</span>
                <span class="text-xs">{{ updateInfo.lastSeen }}</span>
              </div>
              <router-link v-if="!/(4G Box)/.test(updateInfo.type) && checkAddons()" class="btn-green-outline ml-4" :to="'/gps-unit/customer/' + updateInfo.parent_id + '/-/' + updateInfo._id" target="_blank">
                Track
                <BaseIcon icon="map-marker-alt" />
              </router-link>
            </div>
          </div>
          <div class="w-full md:w-1/2 clearfix">
            <button class="btn-blue-outline float-right" @click.prevent="$modal.show('update-alarm-contract')" v-if="!new RegExp('(SecurDesktop)').test(updateInfo.type)">
              {{ $t("alarm_view.show_action_documents") }}
              <BaseIcon icon="arrow-right" />
            </button>
            <!-- SEC-336: replace this device with a new one. Admin only - the
                 flow retires the old device (its notifications, tunnel, alarm
                 central, IMEI and telematics number are all removed and it is
                 moved to RMA), which no other role may do. The server route is
                 admin only as well. -->
            <button class="btn-blue-outline float-right mr-2" @click.prevent="startReplaceDevice()" v-if="user.role == 'admin' && !new RegExp('(SecurDesktop)').test(updateInfo.type)">
              {{ $t("alarm_view.replace_device") }}
              <BaseIcon icon="exchange-alt" />
            </button>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.unit_name" type="text" :field_name="$t('alarm_view.name_of_product')" rules="required" />
          </div>
          <!-- start move alarm -->
          <div class="w-full md:w-1/2 px-2" v-if="user.role == 'admin' || user.role == 'reseller' || user.role == 'superuser'">
            <BaseSelect
              v-model="customer_id"
              :options="customers"
              optionSelector="_id"
              nameSelector="name"
              field_name="Kund"
              rules="required"
              @change="
                filterUnitByCustomer();
                updateInfo.parent_id = '';
              "
            />
          </div>
          <div class="w-full md:w-1/2 px-2" v-if="user.role == 'admin' || user.role == 'reseller' || user.role == 'superuser'">
            <ValidationProvider name="Verksamhet" rules="required" v-slot="{ classes, errors }">
              <div class="input-validate" :class="classes">
                <label class="text-gray-700 text-sm font-bold pb-2 font-serif">{{ $t("alarm_view.department") }}<b class="text-red-500 ml-1">*</b></label>
                <select v-model="updateInfo.parent_id" class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-4 border-gray-300 transition duration-500 px-3 pt-2 pb-2 hover:border-gray-400">
                  <option value="">{{ $t("alarm_view.select_business") }}</option>
                  <option :value="o['unit_id']" v-for="(o, i) in customer_units" :key="i">{{ o["name"] }}</option>
                </select>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <!-- end move alarm admin/reseller, v-else below line -->
          <!-- customer/seller can move alarm within unit -->
          <div class="w-full md:w-1/2 px-2" v-else>
            <ValidationProvider name="Verksamhet" rules="required" v-slot="{ classes, errors }">
              <div class="input-validate" :class="classes">
                <label class="text-gray-700 text-sm font-bold pb-2 font-serif">{{ $t("alarm_view.department") }}<b class="text-red-500 ml-1">*</b></label>
                <select v-model="updateInfo.parent_id" class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-4 border-gray-300 transition duration-500 px-3 pt-2 pb-2 hover:border-gray-400" :readonly="user.role == 'user'" :disabled="user.role == 'user'">
                  <option value="">{{ $t("alarm_view.select_business") }}</option>
                  <option :value="o['unit_id']" v-for="(o, i) in units" :key="i">{{ o["name"] }}</option>
                </select>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.type" type="text" field_name="Typ av enhet" readonly disabled />
          </div>
          <!-- START SecurDesktop related-->
          <div class="w-full mx-2 border-b border-secondary-400 mt-5 mb-4" v-if="(user.role == 'admin' || user.role == 'seller') && new RegExp('(SecurDesktop)').test(updateInfo.type)"></div>
          
          <div class="w-full mx-2" v-if="(user.role == 'admin' || user.role == 'seller') && new RegExp('(SecurDesktop)').test(updateInfo.type)">
            <span>{{ $t('change_alarm_plan.securdesktop_config') }}</span>
            <textarea v-model="updateInfo.securDesktop.alarmMessage" class="w-full h-20 mt-5 p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('change_alarm_plan.alarm_text')"></textarea>
            <textarea v-model="updateInfo.securDesktop.endMessage" class="w-full h-20 mt-5 p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('change_alarm_plan.danger_over_message')"></textarea>
          </div>
        
          <div class="w-full mt-3 flex flex-col" v-if="(user.role == 'admin' || user.role == 'seller') && new RegExp('(SecurDesktop)').test(updateInfo.type)">
            <div class="mt-5">
              <h3 class="text-lg font-semibold">{{ $t('change_alarm_plan.contact_persons') }}</h3>

              <div v-for="(contact, index) in updateInfo.securDesktop.contactPersons" :key="index" class="flex items-center space-x-3 mt-3">

                <input v-model="contact.name" type="text" class="border-2 border-gray-300 rounded-lg p-2 w-1/2 focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('change_alarm_plan.name_placeholder')"/>

                <input v-model="contact.phone" type="text" class="border-2 border-gray-300 rounded-lg p-2 w-1/2 focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('change_alarm_plan.phone_placeholder')"/>

                <button v-if="updateInfo.securDesktop.contactPersons.length > 1" class="text-red-500 pl-2" @click.prevent="removeContact(index)">
                  <BaseIcon icon="minus-circle" />
                </button>
              </div>

              <button class="btn-blue-outline mt-2" @click.prevent="addContact">
                {{ $t('change_alarm_plan.add') }} <BaseIcon icon="plus" class="ml-1" />
              </button>
            </div>
          </div>
          <!-- END SecurDesktop related-->


          <!-- Camera related-->

          <div v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(updateInfo.type)" class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.ava_flex.tag_serial_number" type="text" field_name="Tag serial" />
          </div>
          <div v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(updateInfo.type)" class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.ava_flex.webhook" type="text" field_name="Webbhook" />
          </div>
          <div v-if="new RegExp('(Avigilon Alta Compact Dome 5MP)').test(updateInfo.type)" class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.ava_flex.camera_token" type="text" field_name="Token" />
          </div>

          <!-- End camera related-->

          <div v-if="!new RegExp('(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)" class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.phone" type="text" :field_name="$t('alarm_view.phone')" readonly disabled />
            <!-- inventory number sits directly under the telematics number -->
            <BaseInput v-model="updateInfo.inventory_number" type="text" :field_name="$t('alarm_view.inventory_number')" />
          </div>
          <div v-if="!new RegExp('(Avigilon Alta Compact Dome 5MP)|(SecurDesktop)').test(updateInfo.type)" class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.modelnumber" type="text" :field_name="$t('alarm_view.serial_number')" readonly disabled />
            <!-- SecurTrack / SecurTool stay in the right column, beside the inventory number -->
            <div class="mt-4" v-if="user.role == 'admin' || user.role == 'seller'">
              <div class="flex">
                <div v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)" class="w-full md:w-1/3">
                  <BaseSwitch v-model="updateInfo.gps_active" field_name="SecurTrack" />
                </div>
                <div v-if="!new RegExp('(SRT334)|(SRT330)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)" class="w-full md:w-1/3">
                  <BaseSwitch v-model="updateInfo.gps_log_active" field_name="SecurTool" />
                </div>
              </div>
            </div>
          </div>

          <!-- an SRT430 display that raises alarms has no GPS: a fixed position stands in for it -->
          <div v-if="updateInfo.type === 'SRT430' && user.role == 'admin'" class="w-full px-2 mt-4">
            <StaticPositionPicker :key="updateInfo._id" v-model="updateInfo.static_position" />
          </div>

          <div class="w-full md:w-1/3 px-2 mt-4" v-if="!new RegExp('(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(4G Box)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)').test(updateInfo.type)">
            <BaseSelect v-model="updateInfo.link_validity" :options="validityTime" :field_name="$t('alarm_view.link_validity')" nameSelector="name" optionSelector="time" rules="required" />
          </div>

          <div class="w-full mx-2 border-b border-secondary-400 mt-5 mb-4" v-if="(user.role == 'admin' || user.role == 'reseller' || user.role == 'seller')"></div>

          <!-- Notes section (collapsible) -->
          <div class="w-full" v-if="(user.role == 'admin' || user.role == 'seller' || user.role == 'reseller')">
            <div class="w-full px-4 py-3 cursor-pointer bg-primary-50 border border-primary-200 hover:bg-primary-100 transition-colors" :class="isNotesVisible ? 'rounded-t-lg border-b-0' : 'rounded-lg'" @click="isNotesVisible = !isNotesVisible">
              <div class="flex items-center justify-between">
                <div class="text-primary-700 font-bold text-base font-serif flex items-center">
                  {{ $t('notes.notes_section') }}
                  <span v-if="updateInfo.admin_device_notes || updateInfo.reseller_device_notes" class="inline-block w-2.5 h-2.5 rounded-full bg-accent-400 ml-2" :title="$t('notes.has_notes_indicator')"></span>
                </div>
                <div class="text-primary-500">
                  <BaseIcon v-if="!isNotesVisible" icon="chevron-down" />
                  <BaseIcon v-if="isNotesVisible" icon="chevron-up" />
                </div>
              </div>
            </div>

            <div v-if="isNotesVisible" class="px-4 pt-3 pb-4 bg-primary-50 border border-t-0 border-primary-200 rounded-b-lg">
              <!-- Admin device notes -->
              <div class="w-full mb-4" v-if="(user.role == 'admin' || user.role == 'seller')">
                <span class="mx-2 text-xs text-gray-500 font-semibold uppercase">{{ $t('notes.admin_notes_label') }}</span>
                <textarea v-model="updateInfo.admin_device_notes" class="w-full my-2 h-36 p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('notes.admin_notes_placeholder')" :disabled="isAdminNotesDisabled"></textarea>
                <button v-if="(user.role == 'admin')" class="btn-blue-outline ml-2 my-1" @click="toggleNotesLock('admin')">
                  {{ isAdminNotesDisabled ? $t('notes.unlock_notes') : $t('notes.lock_notes') }}
                  <BaseIcon :icon="isAdminNotesDisabled ? 'lock' : 'lock-open'" class="ml-1"/>
                </button>
              </div>

              <!-- Reseller device notes -->
              <div class="w-full" v-if="(user.role == 'admin' || user.role == 'reseller')">
                <span class="mx-2 text-xs text-gray-500 font-semibold uppercase">{{ $t('notes.reseller_notes_label') }}</span>
                <textarea v-model="updateInfo.reseller_device_notes" class="w-full my-2 h-36 p-4 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" :placeholder="$t('notes.reseller_notes_placeholder')" :disabled="isResellerNotesDisabled"></textarea>
                <button v-if="(user.role == 'reseller' || user.role == 'admin')" class="btn-blue-outline ml-2 my-1" @click="toggleNotesLock('reseller')">
                  {{ isResellerNotesDisabled ? $t('notes.unlock_notes') : $t('notes.lock_notes') }}
                  <BaseIcon :icon="isResellerNotesDisabled ? 'lock' : 'lock-open'" class="ml-1"/>
                </button>
              </div>
            </div>
          </div>
          <!-- End Notes section -->

          <div class="w-full mx-2 border-b border-secondary-400 mt-5 mb-4" v-if="(user.role == 'admin' || user.role == 'seller' || (user.role == 'reseller' && user.reseller_special_access.indexOf('sc_device_setting') > -1)) && !new RegExp('(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)"></div>

          <div class="w-full flex flex-wrap" v-if="(user.role == 'admin' || user.role == 'seller' || (user.role == 'reseller' && user.reseller_special_access.indexOf('sc_device_setting') > -1)) && !new RegExp('(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)">
            <div class="w-full px-2 text-sm cursor-pointer" @click="isConfigVisible = !isConfigVisible">
              <div class="clear-both">
                <div class="float-left text-gray-600 font-bold pb-2 font-serif">{{ $t("alarm_view.additional_services") }}</div>
                <div class="float-right">
                  <BaseIcon v-if="!isConfigVisible" class="" icon="chevron-down" />
                  <BaseIcon v-if="isConfigVisible" class="" icon="chevron-up" />
                </div>
              </div>
            </div>
          </div>

          <div class="w-full flex flex-wrap" v-if="(user.role == 'admin' || user.role == 'seller' || (user.role == 'reseller' && user.reseller_special_access.indexOf('sc_device_setting') > -1)) && isConfigVisible && !new RegExp('(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)').test(updateInfo.type)">
            <div class="w-full md:w-1/2 px-2 mt-5" v-if="updateInfo.type !== 'securapp_eb10'">
              <div class="w-full flex flex-col">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">
                  {{ getInternalDevicesAlertType() }}
                  <span v-if="new RegExp('^SRT').test(updateInfo.type)">(SRT)</span>
                  <span v-if="new RegExp('^TWIG').test(updateInfo.type)">(TWIG)</span>
                  <span v-if="new RegExp('^4G Box').test(updateInfo.type)">(4G Box)</span>
                  <span v-if="new RegExp('^AJAX').test(updateInfo.type)">(AJAX)</span>
                  <span v-if="isAppDevice">(App)</span>
                  <span v-if="isEmeritOsmDevice">(Emerit)</span>
                </div>
                <div class="w-full">
                  <treeselect ref="interdeviceTreeSelect" v-model="interdeviceAlertSelectNodes" :options="interdeviceAlerts" :alwaysOpen="true" :appendToBody="false" :defaultExpandLevel="2" :disableBranchNodes="false" :showCount="true" showCountOf="LEAF_DESCENDANTS" openDirection="below" :searchable="true" :maxHeight="500" :limit="2" :clearable="false" :multiple="true" value-consists-of="LEAF_PRIORITY" valueFormat="object" noChildrenText="No Devices" class="treeselect-inline">
                    <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="[labelClassName, node.isNew ? 'bg-yellow-50' : '']" class="text-sm">
                      {{ node.label }}
                      <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                    </label>
                  </treeselect>
                </div>

                <div class="w-full mt-4" v-if="(new RegExp('(^TWIG)|(^SRT40)').test(updateInfo.type) || isAppDevice || isEmeritOsmDevice) && interdeviceAlertSelectNodes.length > 0">
                  <BaseTextarea rows="1" v-model="updateInfo.vibration_pushb_template" maxlength="130" field_name="On-Screen Message Push-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_pushb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_pushb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_pushb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.vibration_pushb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                  <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(updateInfo.type) || isAppDevice || isEmeritOsmDevice">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.pushb.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.pushb.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.pushb.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.pushb.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="(new RegExp('^TWIG|(^SRT40)').test(updateInfo.type) || isAppDevice || isEmeritOsmDevice) && interdeviceAlertSelectNodes.length > 0">
                  <BaseTextarea rows="1" v-model="updateInfo.vibration_mandown_template" maxlength="130" field_name="On-Screen Message Man-Down" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_mandown_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_mandown_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_mandown_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.vibration_mandown_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                  <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(updateInfo.type) || isAppDevice || isEmeritOsmDevice">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.mandown.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.mandown.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.mandown.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.mandown.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="new RegExp('^TWIG|(^SRT40)').test(updateInfo.type) && interdeviceAlertSelectNodes.length > 0">
                  <BaseTextarea rows="1" v-model="updateInfo.vibration_callb_template" maxlength="130" field_name="On-Screen Message Call-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_callb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.vibration_callb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                  <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(updateInfo.type) || isAppDevice">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="new RegExp('(^SRT40)').test(updateInfo.type) && interdeviceAlertSelectNodes.length > 0">
                  <BaseTextarea rows="1" v-model="updateInfo.vibration_callb2_template" maxlength="130" field_name="On-Screen Message Call-Button 2" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_callb2_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb2_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_callb2_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.vibration_callb2_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                  <div class="mt-2 text-xs text-gray-600">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb2.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb2.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb2.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.callb2.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="isAppDevice && interdeviceAlertSelectNodes.length > 0">
                  <BaseTextarea rows="1" v-model="updateInfo.vibration_timer_alarm_template" maxlength="130" field_name="On-Screen Message Timer Alarm" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('vibration_timer_alarm_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('vibration_timer_alarm_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.vibration_timer_alarm_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                  <div class="mt-2 text-xs text-gray-600" v-if="new RegExp('^SRT40').test(updateInfo.type) || isAppDevice">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.timer_alarm.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.timer_alarm.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.timer_alarm.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.timer_alarm.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="new RegExp('^AJAX Hub').test(updateInfo.type) && interdeviceAlertSelectNodes.length > 0">
                  <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">AJAX Hub Alert Settings</div>
                  <div class="mt-2 text-xs text-gray-600">
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.ajax_critical.text" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Display Text</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.ajax_critical.blink" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">LED Blink</span>
                    </label>
                    <label class="inline-flex items-center mr-3">
                      <input type="checkbox" v-model="updateInfo.osm_settings.ajax_critical.vibration" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Vibration</span>
                    </label>
                    <label class="inline-flex items-center">
                      <input type="checkbox" v-model="updateInfo.osm_settings.ajax_critical.sound" class="form-checkbox h-4 w-4 text-blue-600">
                      <span class="ml-1">Sound</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="w-full md:w-1/2 px-2 mt-5 py-4 md:py-0 border-t md:border-t-0">
              <BaseSelect v-model="updateInfo.sms_alert" :options="sms_alerts" field_name="SMS" nameSelector="name" optionSelector="id" />
              <div class="w-full mt-3 flex flex-col" v-if="updateInfo.sms_alert != ''">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">Nummer <b class="text-xs italic font-normal font-sans text-secondary-500">(Fullständigt mobilnummer med land/riktnummer)</b></div>
                <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in updateInfo.sms_alert_phone" :key="i">
                  <div class="w-11/12">
                    <ValidationProvider :name="'SMS Nummer ' + (i + 1)" rules="required|sms_msisdn|max:15" v-slot="{ classes, errors }">
                      <div class="input-validate" :class="classes">
                        <input v-model="n.msisdn" type="text" @keypress="isNumber($event)" maxlength="15" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-3 py-2" />
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <button class="w-1/12 text-red-500 pl-2" @click.prevent="removeSMSInput(i)"><BaseIcon icon="minus-circle" /></button>
                </div>
                <div class="w-full">
                  <button class="btn-blue-outline mt-2" @click.prevent="addSMSInput()">Tillägga <BaseIcon icon="plus" class="ml-1" /></button>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_pushb' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_pushb_template" maxlength="160" field_name="SMS Push-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_pushb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_pushb_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_pushb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_mandown' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_mandown_template" maxlength="160" field_name="SMS Man-Down" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_mandown_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_mandown_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_mandown_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_callb' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_callb_template" maxlength="160" field_name="SMS Call-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_callb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_callb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_callb2' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_callb2_template" maxlength="160" field_name="SMS Call-Button 2" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_callb2_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_callb2_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_callb2_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <!-- Five push button -->
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_five_push' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_five_push_template" maxlength="160" field_name="SMS 5 button push" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_five_push_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_five_push_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_five_push_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <!-- Timer alarm -->
                <div class="w-full mt-4" v-if="updateInfo.sms_alert == 'sms_timer_alarm' || updateInfo.sms_alert == 'sms_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.sms_timer_alarm_template" maxlength="160" field_name="SMS Timer Alarm" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('sms_timer_alarm_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('sms_timer_alarm_template', '<SecurCloud>')">SecurCloud<BaseIcon icon="map-marker-alt" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.sms_timer_alarm_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!/(4G Box)|(AJAX (?!Hub))/.test(updateInfo.type)" class="w-full md:w-1/2 px-2 mt-5 py-4 border-t">
              <BaseSelect v-model="updateInfo.display_alert" :options="display_alerts" field_name="Display SRT 330/430" nameSelector="name" optionSelector="id" />
              <div class="w-full mt-3 flex flex-col" v-if="updateInfo.display_alert != ''">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">Nummer <b class="text-xs italic font-normal font-sans text-secondary-500">(Fullständigt mobilnummer med land/riktnummer)</b></div>
                <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in updateInfo.display_alert_phone" :key="i">
                  <div class="w-11/12">
                    <ValidationProvider :name="'Display Nummer ' + (i + 1)" rules="required|sms_msisdn|max:15" v-slot="{ classes, errors }">
                      <div class="input-validate" :class="classes">
                        <input v-model="n.msisdn" type="text" @keypress="isNumber($event)" maxlength="15" class="w-full bg-gray-100 rounded text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-3 py-2" />
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <button class="w-1/12 text-red-500 pl-2" @click.prevent="removeDisplayInput(i)"><BaseIcon icon="minus-circle" /></button>
                </div>
                <div class="w-full">
                  <button class="btn-blue-outline mt-2" @click.prevent="addDisplayInput()">Tillägga <BaseIcon icon="plus" class="ml-1" /></button>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.display_alert == 'display_pushb' || updateInfo.display_alert == 'display_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.display_pushb_template" maxlength="160" field_name="Display Push-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_pushb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_pushb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_pushb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.display_pushb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.display_alert == 'display_mandown' || updateInfo.display_alert == 'display_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.display_mandown_template" maxlength="160" field_name="Display Man-Down" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_mandown_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_mandown_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_mandown_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.display_mandown_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.display_alert == 'display_callb' || updateInfo.display_alert == 'display_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.display_callb_template" maxlength="160" field_name="Display Call-Button" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_callb_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.display_callb_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.display_alert == 'display_callb2' || updateInfo.display_alert == 'display_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.display_callb2_template" maxlength="160" field_name="Display Call-Button 2" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_callb2_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb2_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_callb2_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.display_callb2_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
                <div class="w-full mt-4" v-if="updateInfo.display_alert == 'display_timer' || updateInfo.display_alert == 'display_both'">
                  <BaseTextarea rows="2" v-model="updateInfo.display_timer_template" maxlength="160" field_name="Display Timer alarm" rules="required" />
                  <div class="">
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="applyStandardTemplate('display_timer_template')">Default</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_timer_template', '<LarmNamn>')">Larmnamn</button>
                    <button class="btn-secondary-outline text-xxs mt-1 mr-1" @click.prevent="insertPlaceholder('display_timer_template', '<RF-Tagg>')">RF-Tagg<BaseIcon icon="wifi" class="ml-1" /></button>
                    <button class="btn-red-outline text-xxs mt-1" @click.prevent="updateInfo.display_timer_template = ''">Clear<BaseIcon icon="backspace" class="ml-1" /></button>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full px-4 py-4 mt-5 bg-gray-50" v-if="!/(4G Box)|(AJAX)/.test(updateInfo.type)">
              <label class="inline-flex items-center"> <input v-model="updateInfo.send_to_alarm_center" type="checkbox" class="form-checkbox h-4 w-4" /><span class="ml-2 text-gray-600 text-sm font-serif font-bold">{{ $t('alarm_info.send_to_alarm_center') }}</span> </label>
              <template v-if="updateInfo.send_to_alarm_center">
                <div class="w-full" v-for="r in reportTypes" :key="r.id">
                  <label class="inline-flex items-center mt-3">
                    <input v-model="updateInfo.tunnel_settings" :value="r.id" type="checkbox" class="form-checkbox h-3 w-3" /><span class="ml-2 text-sm font-sans font-semibold">{{ r.name }}</span>
                  </label>
                </div>
              </template>
            </div>
          </div>
          <!-- SRT430: does not alarm to the alarm central by default. It is
               switched on here, at the bottom like for other alarms; the alarm
               central and the alarm plan are then filled in under the device
               documentation. (The device settings above do not show for it.) -->
          <div v-if="updateInfo.type === 'SRT430' && (user.role == 'admin' || user.role == 'seller' || (user.role == 'reseller' && user.reseller_special_access.indexOf('sc_device_setting') > -1))" class="w-full px-4 py-4 mt-5 bg-gray-50">
            <label class="inline-flex items-center"> <input v-model="updateInfo.send_to_alarm_center" type="checkbox" class="form-checkbox h-4 w-4" /><span class="ml-2 text-gray-600 text-sm font-serif font-bold">{{ $t('alarm_info.send_to_alarm_center') }}</span> </label>
            <template v-if="updateInfo.send_to_alarm_center">
              <div class="w-full" v-for="r in reportTypes" :key="r.id">
                <label class="inline-flex items-center mt-3">
                  <input v-model="updateInfo.tunnel_settings" :value="r.id" type="checkbox" class="form-checkbox h-3 w-3" /><span class="ml-2 text-sm font-sans font-semibold">{{ r.name }}</span>
                </label>
              </div>
            </template>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <div class="modal-footer">
      <div class="footer-container clearfix">
        <router-link tag="button" v-if="(user.role == 'admin' || user.role == 'seller') && updateInfo" class="btn-blue-outline px-3 py-2 float-left" :to="'/admin/skapa-larm/' + customerId + '/' + updateInfo.parent_id + '/' + updateInfo._id">
          Kopiera
          <BaseIcon icon="clipboard" class="ml-1" />
        </router-link>
        <button v-else class="btn-red-outline px-3 py-2 float-left" @click="hide('update-alarm')">{{ $t("user_actions.cancel") }}<BaseIcon icon="times-circle" class="ml-1" /></button>
        <button class="btn-green px-3 py-2 float-right" @click="saveAlarm()">{{ $t("user_actions.save") }}<BaseIcon icon="save" class="ml-1" /></button>
      </div>
    </div>

    <!-- SEC-328: moving a device to another department carries its OSM and SMS
         notification settings along, and those belong to the old department, so
         ask before the move completes. This sits over the whole modal rather
         than in the footer: the footer is pinned to the bottom of a height:auto
         modal, so a taller footer hangs outside the modal box. Its z-index is
         above 999, which is where vue-treeselect puts the open On-Screen
         Message list, so the box is never hidden behind that list. -->
    <div class="fixed inset-0 flex items-center justify-center p-5" style="background: rgba(0, 0, 0, 0.45); z-index: 1000" v-if="moveAskingAboutAddons">
      <div class="bg-white rounded shadow-lg p-5 w-full" style="max-width: 460px">
        <div class="text-base font-bold text-gray-800 font-serif mb-2">{{ $t("alarm_view.move_reset_addons_question") }}</div>
        <div class="text-xs text-gray-600 mb-4">{{ $t("alarm_view.move_reset_addons_hint") }}</div>
        <div class="clearfix">
          <button type="button" class="btn-green px-3 py-2 mr-2 mb-1" @click="finishMove(true)">{{ $t("alarm_view.move_reset_addons_yes") }}</button>
          <button type="button" class="btn-blue-outline px-3 py-2 mr-2 mb-1" @click="finishMove(false)">{{ $t("alarm_view.move_reset_addons_no") }}</button>
          <button type="button" class="btn-red-outline px-3 py-2 mb-1" @click="cancelMove()">{{ $t("user_actions.cancel") }}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { STANDARD_MESSAGE_TEMPLATES } from "@/constants/alarmMessageTemplates";
import StaticPositionPicker from "@/components/static_position_picker";

const MODAL_WIDTH = 800;

export default {
  components: {
    Treeselect,
    StaticPositionPicker,
  },

  props: {
    alarmInfo: {
      required: true,
      default: null,
    },
    units: {
      required: true,
      default: null,
    },
    customerId: {
      default: "",
    },
    id: {
      default: "-",
    },
    unitAlarms: {
      required: true,
    },
    devicesTree: {
      default: [],
    },
  },

  watch: {
    // SEC-328: a different device means the pending move question is stale.
    // A separate watcher so the existing alarmInfo watcher stays as it is.
    updateInfo() {
      this.moveAskingAboutAddons = false;
      this.resetAddonServicesOnMove = null;
    },
    alarmInfo(newVal) {
      // eslint-disable-line
      this.updateInfo = _.cloneDeep(newVal);
      this.updateInfo.ava_flex = this.updateInfo.ava_flex || {};
      this.updateInfo.admin_device_notes || "";
      this.updateInfo.reseller_device_notes || "";
      this.updateInfo.securDesktop = this.updateInfo.securDesktop || {};
      this.updateInfo.osm_settings = this.updateInfo.osm_settings || {
        pushb: { blink: true, vibration: true, sound: true, text: true },
        mandown: { blink: true, vibration: true, sound: true, text: true },
        callb: { blink: true, vibration: true, sound: true, text: true },
        callb2: { blink: true, vibration: true, sound: true, text: true },
        ajax_critical: { blink: true, vibration: true, sound: true, text: true },
        timer_alarm: { blink: true, vibration: true, sound: true, text: true }
      };
      // Older alarm documents predate the timer_alarm OSM key — default it so
      // the checkbox v-models stay reactive.
      if (!this.updateInfo.osm_settings.timer_alarm) {
        this.$set(this.updateInfo.osm_settings, "timer_alarm", { blink: true, vibration: true, sound: true, text: true });
      }
      if (this.updateInfo.static_position === undefined) {
        this.$set(this.updateInfo, "static_position", null);
      }
      if (this.updateInfo.vibration_timer_alarm_template == undefined) {
        this.$set(this.updateInfo, "vibration_timer_alarm_template", "");
      }
      if (!this.updateInfo.securDesktop.contactPersons || this.updateInfo.securDesktop.contactPersons.length === 0) {
        this.$set(this.updateInfo.securDesktop, "contactPersons", [{ name: "", phone: "" }]);
      }
      // start move alarm
      if (this.user.role == "admin" || this.user.role == "reseller" || this.user.role == "superuser") {
        this.setCustomerId();
        this.filterUnitByCustomer();
      }
      // end move alarm
      this.isConfigVisible = false;
      this.populateInterDeviceAlertTree();
      this.ensureAtLeastOneContact();
    },
    devicesTree(newVal) {
      // eslint-disable-line
      this.unitDevicesTree = _.cloneDeep(newVal);
      this.populateInterDeviceAlertTree();
    },
    customers() {
      // eslint-disable-line
      this.setCustomerId();
      if (this.user.role == "admin" || this.user.role == "reseller" || this.user.role == "superuser") this.filterUnitByCustomer();
    },
    all_units() {
      // eslint-disable-line
      this.filterUnitByCustomer();
    },
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    // SEC-328: the roles and device types that can see and manage the OSM/SMS
    // add-on services block. Only they are asked about clearing it on a move -
    // nobody is asked about something they cannot see.
    canManageAddonServices() {
      if (!this.updateInfo) return false;

      const role = this.user.role;
      let mayManage = role == "admin" || role == "seller";

      if (role == "reseller" && this.user.reseller_special_access) {
        mayManage = this.user.reseller_special_access.indexOf("sc_device_setting") > -1;
      }

      if (!mayManage) return false;

      // device types that have no add-on services block at all
      return !new RegExp("(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(^TELTONIKA)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)").test(this.updateInfo.type);
    },
    /** App-paired device types — alarms arrive via the mobile app (SecurApp). */
    isAppDevice() {
      return !!this.updateInfo && /^SecurApp$/.test(this.updateInfo.type);
    },
    // Emerit devices trigger an OSM on TWIG and SRT recipients (SEC-322) and
    // share the WG100/WG200 OSM config. This includes a standalone e-B10, which
    // reports to the Emerit TCP server like the WG units. Once paired with
    // SecurApp the type becomes 'securapp_eb10' and OSM config is hidden.
    isEmeritOsmDevice() {
      return !!this.updateInfo && /^EMERIT/.test(this.updateInfo.type);
    },
  },

  data() {
    return {
      updateInfo: null,
      unitDevicesTree: [],
      // SEC-328: the "clear the add-on services?" question, asked when the
      // department is changed and Save is pressed
      moveAskingAboutAddons: false,
      resetAddonServicesOnMove: null,
      // start move alarm
      customer_id: "",
      customers: [],
      all_units: [],
      customer_units: [],
      // end move alarm
      validityTime: [
        { name: "30 minuter", time: 1800 },
        { name: "1 timme", time: 3600 },
        { name: "3 timmar", time: 10800 },
        { name: "6 timmar", time: 21600 },
        { name: "12 timmar", time: 43200 },
      ],
      interdeviceAlertsDefault: [
        { level: "event", id: "all", label: "All (Default)", isDisabled: false, isDefaultExpanded: false, children: null, message: "<Event> <DeviceName> <RF-Tagg>" },
        { level: "event", id: "push_button", label: "Push Button", isDisabled: false, isDefaultExpanded: false, children: null, message: "Skarpt <DeviceName> <RF-Tagg>" },
        { level: "event", id: "call_b", label: "Call Button", isDisabled: false, isDefaultExpanded: false, children: null, message: "Internt <DeviceName> <RF-Tagg>" },
        { level: "event", id: "call_b2", label: "Call Button 2", isDisabled: false, isDefaultExpanded: false, children: null, message: "Internt 2 <DeviceName> <RF-Tagg>" },
        { level: "event", id: "man_down", label: "Man Down", isDisabled: false, isDefaultExpanded: false, children: null, message: "Man-Down <DeviceName> <RF-Tagg>" },
        { level: "event", id: "4gbox", label: "4G Box", isDisabled: false, isDefaultExpanded: false, children: null, message: "" },
        { level: "event", id: "five_push", label: "5 button push", isDisabled: false, isDefaultExpanded: false, children: null, message: "Provlarm <DeviceName> <RF-Tagg>" },
        { level: "event", id: "ajax_critical", label: "AJAX SOS", isDisabled: false, isDefaultExpanded: false, children: null, message: "" },
        { level: "event", id: "timer_alarm", label: "Timer alarm", isDisabled: false, isDefaultExpanded: false, children: null, message: "Timer Alarm <DeviceName> <RF-Tagg>" },
      ],
      interdeviceAlerts: [],
      interdeviceAlertSelectNodes: [],
      sms_alerts: [
        { id: "sms_pushb", name: "Push B" },
        { id: "sms_mandown", name: "Man Down" },
        { id: "sms_callb", name: "Call B" },
        { id: "sms_callb2", name: "Call B 2" },
        { id: "sms_4gbox", name: "4G Box" },
        { id: "sms_five_push", name: "5 button push (provlarm)" },
        { id: "sms_ajax_critical", name: "AJAX SOS" },
        { id: "sms_timer_alarm", name: "Timer alarm" },
        { id: "sms_both", name: "Alla" },
      ],
      display_alerts: [
        { id: "display_pushb", name: "Push B" },
        { id: "display_mandown", name: "Man Down" },
        { id: "display_callb", name: "Call B" },
        { id: "display_callb2", name: "Call B 2" },
        { id: "display_4gbox", name: "4G Box" },
        { id: "display_ajax_critical", name: "AJAX SOS" },
        { id: "display_timer", name: "Timer alarm" },
        { id: "display_both", name: "Alla" },
      ],
      reportTypes: [{ name: "Internlarm", id: "call_b" }],
      isConfigVisible: false,
      securDesktop: {
        alarmMessage: "",
        endMessage: "",
        contactPersons: []
      },
      isAdminNotesDisabled: true,
      isResellerNotesDisabled: true,
      isNotesVisible: false,
    };
  },
  methods: {
    // SEC-330: put the standard text into one message field, replacing
    // whatever is in it. This is what the "Default" button does now — it used
    // to add the text to the end of the field, so pressing it twice gave the
    // text twice. The texts themselves live in one place, not per button.
    //
    // Existing devices are never filled in automatically: a device whose field
    // is empty stays empty until someone presses this button.
    applyStandardTemplate(fieldName) {
      const standardText = STANDARD_MESSAGE_TEMPLATES[fieldName];
      if (standardText === undefined) return;

      this.$set(this.updateInfo, fieldName, standardText);
    },

    // SEC-361: what the Larmnamn / RF-Tagg / SecurCloud buttons do. The
    // placeholder goes at the end of the text, as before, but no longer glued
    // on: pressing Larmnamn and then SecurCloud used to give
    // "<LarmNamn><SecurCloud>", and the link in the SMS could not be opened.
    // One space is put in front, unless the text is empty or already ends with
    // a space or a line break.
    insertPlaceholder(fieldName, placeholder) {
      const text = this.updateInfo[fieldName] || "";
      const endsWithSpace = /\s$/.test(text);

      if (text === "" || endsWithSpace) {
        this.$set(this.updateInfo, fieldName, text + placeholder);
      } else {
        this.$set(this.updateInfo, fieldName, text + " " + placeholder);
      }
    },

    // SEC-328: Save goes through here now. A plain edit saves straight away; a
    // device that has been given a new department asks the add-on services
    // question first, then saves with the answer.
    saveAlarm() {
      const departmentChanged = this.alarmInfo && this.updateInfo && this.alarmInfo.parent_id != this.updateInfo.parent_id;

      // Only the roles that can see and manage the add-on services are asked,
      // and only when the device actually has some. For anyone else, and for
      // a device with nothing to clear, the move behaves exactly as before.
      if (!departmentChanged || !this.canManageAddonServices || !this.deviceHasAddonServices()) {
        this.resetAddonServicesOnMove = null;
        this.updateAlarm();
        return;
      }

      this.moveAskingAboutAddons = true;
    },

    // SEC-328: true when the device has an add-on service set up. Only what
    // is visible on the screen counts: the SMS type, the Display type, and the
    // devices ticked in the On-Screen Message tree. Many devices only carry
    // empty values ("" and empty lists); those have nothing to clear, so they
    // move without the question.
    deviceHasAddonServices() {
      const info = this.updateInfo;
      if (!info) return false;

      // An SMS or Display alert type is chosen. "" or missing means the
      // service is off, and then any numbers stored underneath are unused.
      if (info.sms_alert && info.sms_alert !== "") return true;
      if (info.display_alert && info.display_alert !== "") return true;

      // At least one device is ticked in the On-Screen Message tree
      if (this.interdeviceAlertSelectNodes && this.interdeviceAlertSelectNodes.length > 0) return true;

      return false;
    },

    // "Ja" clears the add-on services, "Nej" leaves them. The move itself
    // happens either way.
    finishMove(resetAddonServices) {
      this.resetAddonServicesOnMove = resetAddonServices;
      this.moveAskingAboutAddons = false;
      this.updateAlarm();
    },

    // Back out of the question without saving anything.
    cancelMove() {
      this.moveAskingAboutAddons = false;
      this.resetAddonServicesOnMove = null;
    },

    // SEC-336: open the new action report for a replacement. There is no
    // question at this point - the confirmation happens at save time, in a
    // dialog that also collects the RMA case number. Nothing is saved until
    // that dialog is confirmed.
    startReplaceDevice() {
      if (this.user.role != "admin") return;
      // The saved device, not updateInfo: unsaved edits in this window must
      // not leak into the replacement.
      this.$emit("replaceDevice", this.alarmInfo);
    },

    checkAddons() {
      if (!this.updateInfo || !this.units) return false;
      const unit = this.units.find(u => u.unit_id === this.updateInfo.parent_id);
      if (unit && unit.addons && unit.addons.indexOf('gps_geofence') >= 0) return true;
      if (this.user && this.user.role === 'superuser') {
        const storeAddons = this.$store.state.addons;
        if (storeAddons && storeAddons.customers) {
          const customerAddons = storeAddons.customers.flatMap(c => c.addons || []);
          if (customerAddons.indexOf('gps_geofence') >= 0) return true;
        }
      }
      return false;
    },
    // start move alarm
    getCustomers() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/customer/`)
        .then((response) => {
          this.customers = response.data.data;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getUnits() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/units/`)
        .then((response) => {
          this.all_units = response.data.data;
          this.customer_units = _.filter(this.all_units, { parent_id: this.customer_id });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getResellerCustomers() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/reseller/${this.id}/customers`)
        .then((response) => {
          this.customers = response.data.customers;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getResellerUnits() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/reseller/${this.id}/units`)
        .then((response) => {
          this.all_units = response.data.units;
          this.customer_units = _.filter(this.all_units, { parent_id: this.customer_id });
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    setCustomerId() {
      let customer = _.find(this.customers, { customer_id: this.customerId });
      if (customer) this.customer_id = customer._id;
    },

    filterUnitByCustomer() {
      this.customer_units = _.filter(this.all_units, { parent_id: this.customer_id });
    },

    getUnit(unit_id) {
      let units = this.customer_units;
      if (this.user.role != "admin" && this.user.role != "reseller") units = this.units;

      let unit = _.find(units, { unit_id: unit_id });
      if (unit) return unit;
      else return null;
    },
    // end move alarm

    updateAlarm() {
      this.$refs.formUpdateAlarm.validate().then((success) => {
        if (!success) {
          this.handleError(null, "Några av obligatoriska fält är tomma");
          return;
        }

        let smsPhone = this.updateInfo.sms_alert_phone ? this.filterPhoneNumber(this.updateInfo.sms_alert_phone) : [];
        let displayPhone = this.updateInfo.display_alert_phone ? this.filterPhoneNumber(this.updateInfo.display_alert_phone) : [];

        let interdevice_alerts = this.generateInterDeviceAlertSchema();

        let validContacts = (this.updateInfo.securDesktop && this.updateInfo.securDesktop.contactPersons) ? this.updateInfo.securDesktop.contactPersons.filter(contact => {
          return contact.name && contact.phone && (contact.name.trim() !== '' || contact.phone.trim() !== '');
        }): [];

        let data = {
          unit_name: this.updateInfo.unit_name,
          parent_id: this.updateInfo.parent_id,
          gps_active: this.updateInfo.gps_active,
          gps_log_active: this.updateInfo.gps_log_active,
          link_validity: this.updateInfo.link_validity,
          interdevice_alerts,
          vibration_pushb_template: this.updateInfo.vibration_pushb_template,
          vibration_mandown_template: this.updateInfo.vibration_mandown_template,
          vibration_timer_alarm_template: this.updateInfo.vibration_timer_alarm_template,
          vibration_callb_template: this.updateInfo.vibration_callb_template,
          vibration_callb2_template: this.updateInfo.vibration_callb2_template,
          osm_settings: this.updateInfo.osm_settings,
          sms_alert: this.updateInfo.sms_alert,
          sms_alert_phone: smsPhone,
          sms_pushb_template: this.updateInfo.sms_pushb_template ? this.updateInfo.sms_pushb_template.trim() : "",
          sms_mandown_template: this.updateInfo.sms_mandown_template ? this.updateInfo.sms_mandown_template.trim() : "",
          sms_callb_template: this.updateInfo.sms_callb_template ? this.updateInfo.sms_callb_template.trim() : "",
          sms_callb2_template: this.updateInfo.sms_callb2_template ? this.updateInfo.sms_callb2_template.trim() : "",
          sms_five_push_template: this.updateInfo.sms_five_push_template ? this.updateInfo.sms_five_push_template.trim() : "",
          sms_timer_alarm_template: this.updateInfo.sms_timer_alarm_template ? this.updateInfo.sms_timer_alarm_template.trim() : "",
          display_alert: this.updateInfo.display_alert,
          display_alert_phone: displayPhone,
          display_pushb_template: this.updateInfo.display_pushb_template ? this.updateInfo.display_pushb_template.trim() : "",
          display_mandown_template: this.updateInfo.display_mandown_template ? this.updateInfo.display_mandown_template.trim() : "",
          display_callb_template: this.updateInfo.display_callb_template ? this.updateInfo.display_callb_template.trim() : "",
          display_callb2_template: this.updateInfo.display_callb2_template ? this.updateInfo.display_callb2_template.trim() : "",
          display_timer_template: this.updateInfo.display_timer_template ? this.updateInfo.display_timer_template.trim() : "",
          send_to_alarm_center: this.updateInfo.send_to_alarm_center,
          tunnel_settings: this.updateInfo.tunnel_settings,
          ava_flex : {
            tag_serial_number: this.updateInfo.ava_flex.tag_serial_number,
            webhook: this.updateInfo.ava_flex.webhook,
            camera_token: this.updateInfo.ava_flex.camera_token,
          },
          inventory_number: this.updateInfo.inventory_number,
          securDesktop: {
            alarmMessage: this.updateInfo.securDesktop.alarmMessage,
            endMessage: this.updateInfo.securDesktop.endMessage,
            contactPersons: validContacts,
          },
          admin_device_notes: this.updateInfo.admin_device_notes,
          reseller_device_notes: this.updateInfo.reseller_device_notes,
        };
        // only admin edits the SRT430 fixed position (and the server only takes it from admin/seller)
        if (this.updateInfo.type === "SRT430" && this.user.role === "admin") data.static_position = this.updateInfo.static_position || null;
  
        // start move alarm
        // change fields when device device is moved between unit
        if (this.alarmInfo.parent_id != this.updateInfo.parent_id) {
          let oldUnit = _.find(this.all_units, { unit_id: this.alarmInfo.parent_id });
          let newUnit = _.find(this.all_units, { unit_id: this.updateInfo.parent_id });

          // when moved between units
          if (newUnit) {
            data.alarm_unit_name = newUnit.name;
          }

          // when moved between customer
          if (oldUnit && newUnit && oldUnit.parent_id != newUnit.parent_id) data.interdevice_alerts = [];

          // SEC-328: the answer to the add-on services question. The server
          // clears them only on a yes, and records the choice either way.
          data.reset_addon_services = this.resetAddonServicesOnMove === true;
        }
        // end move alarm

        this.axios
          .put(`${process.env.VUE_APP_SERVER_URL}/alarms/${this.updateInfo._id}`, data)
          .then(() => {
            //eslint-disable-line
            this.$emit("updateAlarm");
            // update device tree
            if (this.alarmInfo.parent_id != this.updateInfo.parent_id) this.$emit("updateDeviceTree");
            this.$modal.hide("update-alarm");
            this.handleSuccess();
          })
          .catch((error) => {
            // Safe-4 refused the save, so nothing changed (SEC-364 B1, C3)
            if (!this.handleSafe4Rejection(error)) this.handleError(error);
          });
      });
    },

    generateInterDeviceAlertSchema() {
      let events = [];

      for (let i = 0; i < this.interdeviceAlertSelectNodes.length; i++) {
        let node = this.interdeviceAlertSelectNodes[i];
        // build desired schema from selected objects
        if (node.level == "event") {
          let devices = [];

          // process all event children
          for (let j = 0; j < node.children.length; j++) {
            let unit = node.children[j];

            // process all unit children
            for (let k = 0; k < unit.children.length; k++) {
              let device = unit.children[k];
              devices.push(device.imei_number);
            }
          }

          // check if event object already exists
          let e = _.findIndex(events, { id: node.id });

          if (e > -1) {
            let event = events[e];
            event.devices = [...event.devices, ...devices];
          } else {
            events.push({
              id: node.id,
              devices,
            });
          }
        } else if (node.level == "unit") {
          let devices = [];

          // devices
          for (let j = 0; j < node.children.length; j++) {
            let device = node.children[j];
            devices.push(device.imei_number);
          }

          // check if event object already exists
          let e = _.findIndex(events, { id: node.event });

          if (e > -1) {
            let event = events[e];
            event.devices = [...event.devices, ...devices];
          } else {
            events.push({
              id: node.event,
              devices,
            });
          }
        } else if (node.level == "device") {
          let e = _.findIndex(events, { id: node.event });

          if (e > -1) {
            let event = events[e];
            event.devices.push(node.imei_number);
          } else {
            events.push({
              id: node.event,
              devices: [node.imei_number],
            });
          }
        }
      }

      return events;
    },

    populateInterDeviceAlertTree() {
      // populate tree
      // generate selected node array
      let selectedNodes = [];
      let interdeviceAlerts = [];

      // populate event based on device type
      for (let i = 0; i < this.interdeviceAlertsDefault.length; i++) {
        let event = this.interdeviceAlertsDefault[i];

        if (this.updateInfo && ((/(^SRT)|(^TWIG)/.test(this.updateInfo.type) && /(^4gbox)|(^ajax_critical)/.test(event.id)) ||
          (/(^TWIG)|(^SRT30)|(^SRT326$)|(^SRT278$)/.test(this.updateInfo.type) && event.id == "call_b2") ||
          (this.updateInfo.type == "4G Box" && event.id != "4gbox") ||
          (/(^AJAX)/.test(this.updateInfo.type) && event.id != "ajax_critical") ||
          (this.isAppDevice && !/^(all|push_button|man_down|timer_alarm)$/.test(event.id)) ||
          // Emerit units only ever report push_button and man_down (SEC-322)
          (this.isEmeritOsmDevice && !/^(all|push_button|man_down)$/.test(event.id))
        )) continue;
        else interdeviceAlerts.push(event);
      }
      this.interdeviceAlerts = interdeviceAlerts;

      // populate event childs
      for (let i = 0; i < this.interdeviceAlerts.length; i++) {
        let event = this.interdeviceAlerts[i];

        if (i == 0) event.isDefaultExpanded = true;
        else event.isDefaultExpanded = false;

        // uniq id to each node
        let unitDevicesTree = _.cloneDeep(this.unitDevicesTree);
        let topUnits = [];
        let units = [];

        for (let j = 0; j < unitDevicesTree.length; j++) {
          let unit = unitDevicesTree[j];
          unit.event = event.id;
          // rename ids so they be unique across all events/units/devices
          unit.id = `${event.id}_${unit.id}`;

          if (event.id == "all" && this.alarmInfo && this.alarmInfo.parent_id == unit.unit_id) unit.isDefaultExpanded = true;
          else unit.isDefaultExpanded = false;

          let children = [];

          for (let k = 0; k < unit.children.length; k++) {
            let device = unit.children[k];
            device.event = event.id;
            device.id = `${event.id}_${unit.id}_${device.id}`;

            if (this.updateInfo && device._id != this.updateInfo._id && ( 
              (/^SRT/.test(this.updateInfo.type) && /^SRT((?!(334)|(330)|(430)).)*$/.test(device.type) ) || 
              (/^TWIG/.test(this.updateInfo.type) && /^TWIG((?!Beacon).)*$/.test(device.type) ) || 
              (/^TWIG/.test(this.updateInfo.type) && /^TWIG((?!Anchor Beacon).)*$/.test(device.type) ) || 
              (/^4G Box/.test(this.updateInfo.type) && /(^TWIG((?!Beacon).)*$)/.test(device.type)) || 
              (/^AJAX/.test(this.updateInfo.type) && /((^TWIG((?!Beacon).)*$))|(^SRT((?!(334)|(330)|(430)|(326)|(306)|(278)|(341)).))/.test(device.type)) ||
              // Emerit reaches both families: TWIG over SMS, SRT over its own socket (SEC-322)
              (this.isEmeritOsmDevice && /(^TWIG((?!Beacon).)*$)|(^SRT((?!(334)|(330)|(430)).)*$)/.test(device.type)))) {
                // todo: 4gbox add srt40 series devices
                children.push(device);
                
                // populate selected nodes if device match
                let ei = this.updateInfo ? _.findIndex(this.updateInfo.interdevice_alerts, { id: event.id }) : -1; 
                if(ei > -1) {
                  let ev = this.updateInfo.interdevice_alerts[ei];
                  if(ev && ev.devices.indexOf(device.imei_number) > -1) selectedNodes.push(device);
                }
            }
          }

          unit.children = children;

          if (this.alarmInfo && this.alarmInfo.parent_id == unit.unit_id) {
            unit.isNew = true;
            if (unit.children.length == 0) unit.isDisabled = true;
            topUnits.push(unit);
          } else if (unit.children.length > 0) units.push(unit);
        }

        event.children = [...topUnits, ...units];
      }

      this.interdeviceAlertSelectNodes = selectedNodes;
    },

    getInternalDevicesAlertType() {
      if (/^SRT40/.test(this.updateInfo.type)) return "On-Screen Message";
      else if (/^SRT/.test(this.updateInfo.type)) return "9-vibb";
      else if (/^TWIG/.test(this.updateInfo.type)) return "On-Screen Message";
      else if (/^4G Box/.test(this.updateInfo.type)) return "On-Screen Message";
      else if (/^AJAX/.test(this.updateInfo.type)) return "On-Screen Message";
      else if (this.isAppDevice) return "On-Screen Message";
      else if (this.isEmeritOsmDevice) return "On-Screen Message";
      else return "N/A";
    },

    addSMSInput() {
      this.updateInfo.sms_alert_phone.push({ msisdn: "" });
    },

    removeSMSInput(i) {
      this.updateInfo.sms_alert_phone.splice(i, 1);
    },

    addDisplayInput() {
      this.updateInfo.display_alert_phone.push({ msisdn: "" });
    },

    removeDisplayInput(i) {
      this.updateInfo.display_alert_phone.splice(i, 1);
    },

    filterPhoneNumber(phoneNumbers) {
      let recipients = [];

      for (let i = 0; i < phoneNumbers.length; i++) {
        let phone = phoneNumbers[i].msisdn.replace(/[^0-9]/g, "");
        recipients.push({
          msisdn: phone,
        });
      }

      recipients = _.uniqBy(recipients, "msisdn");

      return recipients;
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // eslint-disable-next-line
    resetForm() {},

    hide(id) {
      this.$refs.formUpdateAlarm.reset();
      this.$modal.hide(id);
    },
    addContact() {
      this.updateInfo.securDesktop.contactPersons.push({ name: "", phone: "" });
      },
    removeContact(index) {
      if (this.updateInfo.securDesktop.contactPersons.length > 1) {
      this.updateInfo.securDesktop.contactPersons.splice(index, 1);
      }
    },
    ensureAtLeastOneContact() {
      if (!this.updateInfo.securDesktop.contactPersons || this.updateInfo.securDesktop.contactPersons.length === 0) {
      this.$set(this.updateInfo.securDesktop, "contactPersons", [{ name: "", phone: "" }]);
      }
    },
    toggleNotesLock(role) {
      if (role === 'admin') {
        this.isAdminNotesDisabled = !this.isAdminNotesDisabled;
      } else if (role === 'reseller') {
        this.isResellerNotesDisabled = !this.isResellerNotesDisabled;
      }
    }

  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;
    // start move alarm
    if (this.user.role == "admin" || this.user.role == "superuser") {
      this.getCustomers();
      this.getUnits();
    } else if (this.user.role == "reseller" && this.id != "-") {
      this.getResellerCustomers();
      this.getResellerUnits();
    }
    // end move alarm
  },
};
</script>
